import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronUp, faChevronDown } from "@fortawesome/pro-regular-svg-icons";
import * as Styled from "../misc/styled";

const QAListItem = ({ question, answer }) => {
  const [visible, toggleVisibility] = useState(false);

  const handleOnClick = () => {
    toggleVisibility(!visible);
  };

  return (
    <Styled.QAListItemContainer visible={visible}>
      <div className="question" onClick={handleOnClick}>
        <p>{question}</p>
        <div className="toggle">
          <FontAwesomeIcon icon={visible ? faChevronUp : faChevronDown} />
        </div>
      </div>
      <p className="answer">{answer}</p>
    </Styled.QAListItemContainer>
  );
};

export default QAListItem;



// WEBPACK FOOTER //
// ./src/core/admin/components/QA/components/QAListItem.js